import React from 'react';
import * as Styled from './form-section.styles';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ title, children }) => {
  return (
    <Styled.Fieldset>
      <Styled.Legend>{title}</Styled.Legend>
      <Styled.Panel>{children}</Styled.Panel>
    </Styled.Fieldset>
  );
};

export default FormSection;
